import { stockStatusMessages } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import { useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import type { RadioOption } from "src/components/form/radio/radioGroup/RadioGroup"
import { stockStatusOptionMessages } from "./useStockStatusOptions"

export const useIncomingOption = (
	vmsDataSource: "ONE_VMS" | "PVMS" | undefined,
	isIncoming: boolean,
	isDraft: boolean,
): RadioOption => {
	const { formatMessage } = useIntl()
	return useMemo(
		() => ({
			disabledHint: vmsDataSource
				? formatMessage(commonMessages.disabledForVmsVehicle, {
						value: vmsDataSource === "ONE_VMS" ? "OneVMS" : "PVMS",
					})
				: !isIncoming && !isDraft
					? formatMessage(stockStatusOptionMessages.vehicleAlreadyInStock)
					: undefined,
			label: formatMessage(stockStatusMessages.INCOMING),
			value: "INCOMING",
		}),
		[formatMessage, isIncoming, isDraft, vmsDataSource],
	)
}
